<div class="popular-requests block">
  <div class="heading heading_standard heading_centered">
    Popular search requests
  </div>
  <app-tags classes="tags_center" [tags$]="requests$" />
</div>
